// extracted by mini-css-extract-plugin
export var container = "caseStudies-module--container--1GSmt";
export var section = "caseStudies-module--section--mLO1t";
export var image = "caseStudies-module--image--EI8Xx";
export var textContainer = "caseStudies-module--textContainer--vHxil";
export var studyTitle = "caseStudies-module--studyTitle--oUQ3z";
export var studyBody = "caseStudies-module--studyBody--UZyiY";
export var tag = "caseStudies-module--tag--e1rEE";
export var studyCallout = "caseStudies-module--studyCallout--F48pt";
export var buttonContainer = "caseStudies-module--buttonContainer--oj9nI";